import React from 'react';
import PropTypes from 'prop-types';

const RibbonIcon = ({ color }) => {
  return (
    <svg
      fill={color}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 690.95 1000"
      height="24.04px"
      width="19px"
      role="img"
    >
      <title>Ribbon Icon</title>
      <g id="Group_9166" data-name="Group 9166">
        <path
          id="Path_13915"
          data-name="Path 13915"
          className="cls-1"
          d="M830.15,304.49l-12.33-10.91a42,42,0,0,1-10.91-50.67l6.83-16.37A43.92,43.92,0,0,0,785,166.27l-19.17-5.49a45.31,45.31,0,0,1-32.73-41.1V101.85a45.11,45.11,0,0,0-47-43.16,44.58,44.58,0,0,0-5.27.53L663,62a43.17,43.17,0,0,1-46.56-23.28l-8.22-15.06A44.77,44.77,0,0,0,542.47,8.55L527.41,19.47a45.36,45.36,0,0,1-52.06,0L461.64,8.55a44.78,44.78,0,0,0-62.54,9.93,43.26,43.26,0,0,0-3.22,5.13l-8.22,15.06A48.2,48.2,0,0,1,339.72,62l-17.83-2.73a46.3,46.3,0,0,0-53,38.49c-.21,1.31-.36,2.64-.45,4l-1.38,16.44a45.34,45.34,0,0,1-32.74,41.11l-16.44,4.11a43.88,43.88,0,0,0-28.77,60.27L196,240a44.36,44.36,0,0,1-12.33,50.67L169.92,303a44.27,44.27,0,0,0-4.68,62.43,45,45,0,0,0,4.68,4.68l13.71,12.33a42,42,0,0,1,10.92,50.67l-6.84,16.44a43.91,43.91,0,0,0,22.25,58,43.13,43.13,0,0,0,6.52,2.3l16.44,5.5a45.32,45.32,0,0,1,32.74,41.1L267,574.28a45.1,45.1,0,0,0,47.07,43.05,43.43,43.43,0,0,0,4.95-.49l17.82-2.73a43.18,43.18,0,0,1,46.56,23.28l8.22,15.06a44.78,44.78,0,0,0,60.63,18.28,45.47,45.47,0,0,0,5.13-3.22l15.06-10.91a45.31,45.31,0,0,1,52,0l13.72,10.91a44.78,44.78,0,0,0,62.54-9.92,45.6,45.6,0,0,0,3.22-5.14l8.22-15.06a48.21,48.21,0,0,1,47.94-23.28L678,616.84a46.31,46.31,0,0,0,53-38.49c.2-1.31.36-2.63.45-4l1.38-17.82a45.34,45.34,0,0,1,32.74-41.11L782,511.35a43.88,43.88,0,0,0,28.77-60.27l-6.84-16.44A44.39,44.39,0,0,1,816.25,384L830,371.64a44.29,44.29,0,0,0,.18-67.15ZM500,559.11c-121.8,0-220.54-98.73-220.54-220.53S378.22,118,500,118s220.53,98.74,220.53,220.54h0c.18,121.72-98.34,220.53-220.06,220.72H500Z"
          transform="translate(-154.53 0)"
        />
        <circle
          id="Ellipse_6"
          data-name="Ellipse 6"
          className="cls-1"
          cx="345.49"
          cy="338.76"
          r="158.92"
        />
        <path
          id="Path_13916"
          data-name="Path 13916"
          className="cls-1"
          d="M617.11,994.44a10.92,10.92,0,0,1-14.87,4.15,10.8,10.8,0,0,1-4.7-5.28L492.63,726.91a78.35,78.35,0,0,0,15.83-12.12l.76-1.78,1.78.77a109.59,109.59,0,0,0,91.81,5.09,113,113,0,0,0,64.2-65l.76-1.78,1.79.76a101.75,101.75,0,0,0,22.91-1.67l104.4,265.28A10.54,10.54,0,0,1,783.3,930.6L677.81,898.48a6.63,6.63,0,0,0-8.78,3.25c-.06.13-.11.26-.16.39Z"
          transform="translate(-154.53 0)"
        />
        <path
          id="Path_13917"
          data-name="Path 13917"
          className="cls-1"
          d="M317.16,901.87a6.62,6.62,0,0,0-8.56-3.79l-.35.15L202.77,930.35a10.55,10.55,0,0,1-13.57-14.19L293.56,651a101.75,101.75,0,0,0,22.91,1.67l1.78-.76.77,1.78a113,113,0,0,0,64.2,65A109.55,109.55,0,0,0,475,713.67l1.78-.77.76,1.79A78.66,78.66,0,0,0,493.4,726.8L388.53,993.2a10.91,10.91,0,0,1-19.61,1.13Z"
          transform="translate(-154.53 0)"
        />
      </g>
    </svg>
  );
};
export default RibbonIcon;

RibbonIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
